export default "__VITE_ASSET__BArvUDIp__"